import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import Select from "react-select";
import ReactPaginate from "react-paginate";
//import icone
import { RiSearch2Line } from "react-icons/ri";
import ClearFilter from "../../images/clear filter icon.png";
import LimitArrow from "../../images/LimitArrow.svg";
import Loader from "../../component/Admin/Loader";
import { EditEmployeeModal } from "../../component/Modal/AdminModal/EditEmployeeModal";
import { ExportBranchData, ExportMasterBranchData, GetAllBranchlist, GetAllBranchlistAdmin, GetCreditNoteList, GetMasterCorpolist, GetMasterMemberlist,  MasterAdminLoader,ExportCreditNoteData, GetRefundProcessSteps } from "../../Redux/Action/MasterAdminAction";
import UseOutsideClick from "../../component/Admin/UseOutsideClick";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import calender from "../../images/Doctor/calender.png";
import { components } from "react-select";
import AdminLayout from "../../component/layout/AdminLayout/AdminLayout";
import { ToastContainer } from "react-toastify";
import { RefundApproveModal } from "../../component/Modal/AdminModal/RefundApproveModal";
import { Eye, Filter } from "lucide-react";
import { ApproveSureModel } from "../../component/Modal/AdminModal/ApproveSureModel";
import ProcessRefundModel from "../../component/Modal/AdminModal/ProcessRefundModel";
import FilterSidebar from "../../component/Admin/FilterSidebar";
import { ExportRangeSelectModel } from "../../component/Modal/AdminModal/ExportRangeSelectModel";
import ExportModel from "../../component/common/ExportModel";

const CreditNote = () => {
  const location = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [selectpage, setselectpage] = useState("");
  const itemsPerPageOptions = [
    { value: 10, label: 10, id: 1 },
    { value: 25, label: 25, id: 2 },
    { value: 50, label: 50, id: 3 },
  ];
  const statusOptions = [
    { value: "", label: "All" },
    { value: "approve", label: "Approve" },
    { value: "reject", label: "Reject" },
    { value: "pending", label: "Pending" },
  ];
  const [selectedStatus, setSelectedStatus] = useState(null);
  const CreditNoteList = useSelector(
    (state) => state?.MasterAdmin?.CreditNoteList
  );
  useEffect(() => {
    searchParams.delete("search");
    searchParams.delete("corporateID");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    searchParams.delete("refund_status");

    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");

    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete object.search;
    delete object.corporateID;
    delete object.startDate;
    delete object.endDate;
    delete object.refund_status;
    dispatch(GetCreditNoteList({ ...object }));
    dispatch(MasterAdminLoader());
    dispatch(GetAllBranchlistAdmin());
  dispatch(MasterAdminLoader());
  }, []);

  const [Itemperpage, setItemperpage] = useState("");
  const [page, setpage] = useState("");
  const pageCount = Math.ceil(Number(CreditNoteList?.totalCount) / Number(page));

  useEffect(() => {
    if (pageCount && pageCount !== Infinity) {
      setItemperpage(pageCount);
    }
  }, [CreditNoteList]);

  useEffect(() => {
    setpage(itemsPerPageOptions[0]?.value);
  }, []);

  // for select page data
  const onselectedpage = (item) => {
    setpage(item.value);
  
    // Parse the current query string into an object
    const searchParams = new URLSearchParams(location.search);
    let params = {};
  
    searchParams.forEach((value, key) => {
      if (key === 'corporateID') {
        // If 'corporateID' already exists, append the new value
        params[key] = [...(params[key] || []), value];
      } else {
        // Otherwise, just set the value
        params[key] = value;
      }
    });
  
    // Ensure 'corporateID' is an array
    if (params.corporateID && !Array.isArray(params.corporateID)) {
      params.corporateID = [params.corporateID];
    }
  
    // Update the 'limit' and 'page' parameters
    params.limit = item.value;
    params.page = 1;
  
    // Construct the new query string
    const updatedSearchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => updatedSearchParams.append(key, val));
      } else {
        updatedSearchParams.set(key, value);
      }
    });
  
    // Update the URL without reloading the page
    history({
      pathname: "/admin/admin_user/credit_note",
      search: "?" + updatedSearchParams.toString(),
    });
    const params1 = {
      ...filters,
      page: 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: item.value,
      search: Search,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetCreditNoteList(params1));
  dispatch(MasterAdminLoader());
  };

  // for pagination
  const handleFirstPage = () => {
    setselectpage(0);
    const params = {
      ...filters,   // include current filters here
      page: 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      search: Search,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetCreditNoteList(params));
  dispatch(MasterAdminLoader());
  };
  const handleLastPage = () => {
    const lastPage = pageCount - 1;
    setselectpage(lastPage);
    const params = {
      ...filters,   // include current filters here
      page: lastPage + 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      search: Search,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetCreditNoteList(params));
  dispatch(MasterAdminLoader());
  };
  const handlePageChange = (selected) => {
    setselectpage(selected.selected);
  
    const params = {
      ...filters,   // include current filters here
      page: selected.selected + 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      search: Search,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetCreditNoteList(params));
  dispatch(MasterAdminLoader());
  };  

  //for search filter
  const [Search, setSearch] = useState("");
  const submitsearch = (e) => {
    e?.preventDefault();

    const searchParams = new URLSearchParams(location.search);

    searchParams.set("search", Search);
    const params = {
      ...filters,   // include current filters here
      page: 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      search: Search,
    };
      dispatch(GetCreditNoteList(params));
  dispatch(MasterAdminLoader());

  };

  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = () => {
    const params = {
      ...filters,
      search: '',
      page: 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    };
    dispatch(GetCreditNoteList(params));
  dispatch(MasterAdminLoader());
    setselectpage(0);
  };
  
  // for searchable-dropdwon
  const [selectedCorporate, setSelectedCorporate] = useState([]);
  const [filterCorporate, setFilterCorporate] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [error, setError] = useState("");
  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // prevent default behavior
          className="mr-2"
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  function handleSelect(selectedOptions) {
    const selectedIds = selectedOptions?.map((opt) => opt.value) || [];
    const selectedLabels = selectedOptions?.map((opt) => opt.label) || [];
    setSelectedCorporate(selectedIds);
    setFilterCorporate(selectedLabels); 
  
    const sds = location.search
      .slice(1)
      .split("&")
      .filter((item) => item.includes("="));
  
    let object = {};
  
    sds.forEach((item) => {
      let [key, value] = item.split("=");
  
      if (key !== "corporateID" && key !== "page" && value !== "undefined") {
        // Decode value
        value = decodeURIComponent(value).replace(/\+/g, " ");
        object[key] = value;
      }
    });
  
    // Force page = 1
    object.page = 1;
  
    const searchParams = new URLSearchParams();
    Object.entries(object).forEach(([key, value]) => {
      searchParams.set(key, value);
    });
  
    selectedIds.forEach((id) => {
      searchParams.append("corporateID", id);
    });
  
    history({
      pathname: "/admin/admin_user/credit_note",
      search: `?${searchParams.toString()}`,
    });
    dispatch(
      GetCreditNoteList({
        ...object,
        corporateID: selectedIds,
      })
    );
  dispatch(MasterAdminLoader());
  }  

  const Corporatename = useSelector(
    (state) => state?.MasterAdmin?.AllBranchListAdmin?.data
  );
  const AllMasterMemberList = useSelector(
    (state) => state?.MasterAdmin?.AllMasterMemberList?.data
  );

  useEffect(() => {
    const con =
      Corporatename &&
      Corporatename?.map((c) => ({
        value: c._id,
        label: c.corporateName,
        color: c.status ? "black" : "#808080",
      }));
    setOptionList(con);
  }, [Corporatename]);

  const [selectedMasterCorporate, setselectedMasterCorporate] = useState("");
  const [masteroptionList, setMasteroptionList] = useState([]);
  useEffect(() => {
    const con =
      AllMasterMemberList &&
      AllMasterMemberList?.map((c) => ({
        value: c._id,
        label: c.corporateName,
        color: c.status ? "black" : "#808080",
      }));
    setMasteroptionList(con);
  }, [AllMasterMemberList]);


  function handleSelectmaster(selectedOption) {
    const selectedId = selectedOption?.value || "";
    setselectedMasterCorporate(selectedId);
    dispatch(GetAllBranchlistAdmin(selectedId));
  
    const sds = location.search
      .slice(1)
      .split("&")
      .filter((item) => item.includes("="));
  
    let object = {};
    let currentMasterId = "";
  
    sds.forEach((item) => {
      const [key, value] = item.split("=");
  
      if (key === "master_CorpoId") {
        currentMasterId = value;
      } else {
        if (value !== "undefined") {
          if (key === "corporateID") {
            if (!object[key]) object[key] = [];
            object[key].push(value);
          } else if (key !== "page") { //  Ignore old page key
            object[key] = value;
          }
        }
      }
    });
  
    const isSameMaster = selectedId === currentMasterId;
  
    if (!isSameMaster) {
      delete object.corporateID;
      setSelectedCorporate([]);
    }
  
    const updatedParams = {
      ...object,
      master_CorpoId: selectedId,
      page: 1, //  Force page = 1
    };
  
    const searchParams = new URLSearchParams();
    Object.entries(updatedParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => searchParams.append(key, v));
      } else {
        searchParams.set(key, value);
      }
    });
  
    history({
      pathname: "/admin/admin_user/credit_note",
      search: `?${searchParams.toString()}`,
    });
  
    dispatch(GetCreditNoteList(updatedParams));
  dispatch(MasterAdminLoader());
  }

  useEffect(() => {
    const newlimit = searchParams.get("limit");
    if (newlimit?.length > 0) {
      setpage(newlimit);
    }
  }, []);

  useEffect(() => {
    const newcorporateID = searchParams.get("corporateID");
    if (newcorporateID?.length > 0 && newcorporateID !== null) {
      setSelectedCorporate(newcorporateID);
    }
  }, []);

  useEffect(() => {
    const newcorporateID = searchParams.get("master_CorpoId");
    if (newcorporateID?.length > 0 && newcorporateID !== null) {
      setselectedMasterCorporate(newcorporateID);
    }
  }, []);

  useEffect(() => {
    const newpage = searchParams.get("page");
    if (newpage?.length > 0 && newpage !== null) {
      setselectpage(newpage - 1);
    }
  }, [searchParams]);

  const [showdelete, setshowdelete] = useState(false);
  const [selectionRange, setSelectionRange] = useState(null);

  useEffect(() => {
    if (selectedCorporate?.length > 0 || selectionRange?.startDate || selectionRange?.endDate || selectedMasterCorporate?.length > 0 || selectedStatus) {
      setshowdelete(true);
    } else {
      setshowdelete(false);
    }
  }, [selectedCorporate, selectionRange , selectedMasterCorporate , selectedStatus]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //for pagination
  const reactPaginate = {
    previousLabel: "<",
    nextLabel: ">",
    breakLabel: "",
    pageCount: Itemperpage,
    onPageChange: handlePageChange,
    containerClassName: "pagination",
    previousLinkClassName: "pagination__link",
    nextLinkClassName: "pagination__link",
    disabledClassName: "pagination__link--disabled",
    activeClassName: "pagination__link--active",
    forcePage: selectpage,
  };

  const [editEmpModel, setEditEmpModel] = useState(false);
  const [userDetail, setuserDetail] = useState("");

  const [openCalender, setopenCalender] = useState(false);
  const [unixstartDate, setUnixStartDate] = useState(new Date(new Date().setUTCHours(0, 0, 0, 0))?.getTime());
  const [unixendDate, setUnixendDate] = useState(new Date(new Date().setUTCHours(23, 59, 59, 999))?.getTime());
  function formatDate(date) {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  const ref = useRef();
  UseOutsideClick(ref, () => {
    if (openCalender) {
      setopenCalender(false);
    }
  });

  const handleSelection = (range) => {
    setSelectionRange({
      startDate: range.selection.startDate,
      endDate: range.selection.endDate,
      key: "selection",
    });
  
    const startDateText = formatDate(range.selection.startDate);
    const endDateText = formatDate(range.selection.endDate);
  
    const unix_timestamp = new Date(
      new Date(startDateText).setUTCHours(23, 59, 59, 999)
    ).getTime();
  
    const unix_timestamp1 = Math.floor(
      new Date(endDateText).getTime() + 86400000
    );
  
    setUnixStartDate(unix_timestamp);
    setUnixendDate(unix_timestamp1);
  
    const sds = location.search.slice(1).split("&").filter(Boolean);
    let object = {};
  
    sds.forEach((item) => {
      const [key, value] = item.split("=");
      if (!key || typeof value === "undefined") return;
  
      const decodedKey = decodeURIComponent(key);
      const decodedValue = decodeURIComponent(value);
  
      if (decodedKey === "page") return;
  
      if (decodedKey === "corporateID") {
        if (!object[decodedKey]) object[decodedKey] = [];
        object[decodedKey].push(decodedValue);
      } else {
        object[decodedKey] = decodedValue;
      }
    });
  
    const updatedParams = {
      ...object,
      startDate: unix_timestamp,
      endDate: unix_timestamp1,
      page: 1,
    };
  
    const searchParams = new URLSearchParams();
    Object.entries(updatedParams).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        val.forEach((v) => searchParams.append(key, v));
      } else {
        searchParams.set(key, val);
      }
    });
  
    history({
      pathname: "/admin/admin_user/credit_note",
      search: `?${searchParams.toString()}`,
    });
  
    const params = {
      ...filters,
      startDate: unix_timestamp,
      endDate: unix_timestamp1,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      page: 1,
      search: Search,
    };
    dispatch(GetCreditNoteList(params));
  dispatch(MasterAdminLoader());
  };
  

  function formattedStartDate(d) {
    let month = String(d?.getMonth() + 1);
    let day = String(d?.getDate());
    const year = String(d?.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${day}/${month}/${year}`;
  }
    const [showDateWarning, setShowDateWarning] = useState(false);
    const [showExportModel,setShowExportModel] = useState(false);

const handleExportData = (enteredEmail) => {
  if (!selectionRange) {
    setShowDateWarning(true);
    return; // Stop export
  }
  if(!showExportModel){
    setShowExportModel(true);
    return;
}
  const sds = location.search.slice(1).split("&");
  let object = {};

  if (location.search.includes("?")) {
    sds.forEach((item) => {
      const [key, rawValue] = item.split("=");

      const value = decodeURIComponent(rawValue || "");

      if (object[key]) {
        if (Array.isArray(object[key])) {
          object[key].push(value);
        } else {
          object[key] = [object[key], value];
        }
      } else {
        object[key] = value;
      }
    });
  }
  const params = {
    ...filters,
    search: Search,
    startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
    endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
  };
  // Dispatch the export action
  dispatch(ExportCreditNoteData({ ...params ,email: enteredEmail }));
  dispatch(MasterAdminLoader());
};

  const loader = useSelector((state) => state?.MasterAdmin?.corporateloader);

const formatToIST = (ms) => {
  const date = new Date(ms);

  return new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
    .format(date)
    .replace(',', '');
};

  // hadle select status
  function handleSelectStatus(selectedOption) {
    const selectedStatus = selectedOption?.value || "";
    setSelectedStatus(selectedStatus);

    const sds = location.search
      .slice(1)
      .split("&")
      .filter((item) => item.includes("="));

    let object = {};

    sds.forEach((item) => {
      const [key, rawValue] = item.split("=");
      const value = decodeURIComponent(rawValue || "");

      if (key === "corporateID") {
        if (!object[key]) object[key] = [];
        object[key].push(value);
      } else if (key !== "refund_status" && key !== "page") {
        object[key] = value;
      }
    });

    // Force page = 1
    object.page = 1;

    // Add status if selected
    if (selectedStatus) {
      if (!object.refund_status) object.refund_status = [];
      object.refund_status.push(selectedStatus);
    }

    const searchParams = new URLSearchParams();
    Object.entries(object).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        val.forEach((v) => searchParams.append(key, v));
      } else {
        searchParams.set(key, val);
      }
    });

    history({
      pathname: "/admin/admin_user/credit_note",
      search: `?${searchParams.toString()}`,
    });
    setSelectedStatus(selectedStatus);
    dispatch(
      GetCreditNoteList({
        ...object,
        refund_status: object.refund_status,
      })
    );
  dispatch(MasterAdminLoader());
  }
  
  const [refundModal,setRefundModal] = useState(false)
  const [approveReasonModel,setApproveReasonModel] = useState(false)
// filter changes
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const toggleSidebar = () => {
  setIsSidebarOpen(!isSidebarOpen);
};

const [filters, setFilters] = useState({
  categories: [],
  corporateID: [],
  refund_status: [],
});
const handleFilterChange = (newFilters) => {
  setFilters(newFilters);
  return true;
};

const getActiveFilterCount = () => {
  const selectedStatus = filters.refund_status?.map((status) => status.value) || [];
  if(selectionRange?.key === "selection"){
    return filters.categories.length + filters.corporateID.length + selectedStatus.length + 1 ;
  }
  return filters.categories.length + filters.corporateID.length + selectedStatus.length;
};

    const clearAllFilters = () => {
      setFilters({
        categories: [],
        corporateID: [],
        refund_status: [],
      });
      handleFilterChange({
        categories: [],
        corporateID: [],
        refund_status: [],
      });
      setSelectionRange(null);
      searchParams.delete("startDate");
      searchParams.delete("endDate");
      setSearchParams(searchParams);
      setselectpage(0);
      dispatch(
        GetCreditNoteList({
          corporateID: [],
          refund_status: [],
          search: Search,
          page: 1,
        })
      );
  dispatch(MasterAdminLoader());
      setIsSidebarOpen(false);
    };

      const [processModal, setProcessModal] = useState(false);
      const [currentStepData, setCurrentStep] = useState(null);
      const [refundProcessData, setRefundProcessData] = useState(null);

      const getDataRefundProcessSteps = useSelector(
        (state) => state?.MasterAdmin?.RefundProcessSteps
      );

      useEffect(() => {
        if (refundProcessData) {
          dispatch(GetRefundProcessSteps(refundProcessData));
        }
      }, [refundProcessData]);

      const [subStep, setSubStep] = useState(0);

      useEffect(() => {
        let step = 1;
        let sub = 0;
        if (getDataRefundProcessSteps?.request?.request_recieved) {
          step = 1;
          const status = getDataRefundProcessSteps?.status?.status;
          if (status === "pending") {
            step = 2;
          } else if (status === "reject") {
            step = 2;
          } else if (status === "approve") {
            if (getDataRefundProcessSteps?.Processing?.Processing) {
              step=3;
              if(getDataRefundProcessSteps?.refund?.status === "created"){
                sub = 1;
                step=3;
              }else if(getDataRefundProcessSteps?.refund?.status === "processed"){
                sub = 2;
                step=4;
              }else if(getDataRefundProcessSteps?.refund?.status === "failed"){
                sub = 3;
                step=4;
              }
              // const txn = getDataRefundProcessSteps?.transaction_identifiers;
              // if (txn?.RRN) sub = 1;
              // if (txn?.ARN) sub = 2;
              // if (txn?.UTR) sub = 3;
              // if (txn?.RRN && txn?.ARN && txn?.UTR) {
              //   step = 4;
              // }
            }
          }
        }
        setCurrentStep(step);
        setSubStep(sub);
      }, [getDataRefundProcessSteps]);
    
        const handelFilterApply=(filters)=>{
    dispatch(GetCreditNoteList({
      ...filters,
      page: 1,
      search: Search,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    }))
  dispatch(MasterAdminLoader());
  }
  return (
    <>
      {loader && (
        <div>
          <div className="fixed top-0 left-0 right-0 z-40 w-full h-full bg-black bg-opacity-50">
            <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loader />
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
      <AdminLayout>
        <div className="flex flex-col h-[calc(100vh-58px)] px-5 py-5 2xl:justify-between">
          {/* {/ --------------------------------------------Search Bar---------------------------------------------------------- /} */}
          <div className="w-full p-4 mb-5 bg-white rounded-lg">
            <div className="flex flex-col items-start justify-start gap-3 xl:flex-row xl:gap-0 xl:justify-between xl:items-center">
              <div className="relative flex items-center gap-3">
                <div className="absolute top-[8px] left-[20px] text-gray-400 text-2xl">
                  <RiSearch2Line className="w-6 h-6" />
                </div>
                <form
                  onSubmit={(e) => {
                    e?.preventDefault();
                    if (Search.trim() !== "") {
                      submitsearch(e);
                    }
                  }}
                >
                  <input
                    className="h-full bg-[#FFFCE1] border rounded-[8px] py-2 pl-[50px] w-[250px] md:w-[320px] 2xl:w-[350px] placeholder:text-[#47505F]  placeholder:text-[12px] 2xl:placeholder:text-[14px] placeholder:font-medium outline-[#FCDD00]"
                    placeholder="Search By Member, Email, Contact No"
                    value={Search}
                    type="text"
                    onChange={(e) => {
                      const inputValue = e.target.value.trimStart();
                      setSearch(inputValue);
                      if (inputValue.trim() === "") {
                        removeQueryParams();
                      }
                    }}
                  />
                </form>
                <p className="text-[14px] font-semibold">
                  Total Member : {CreditNoteList && CreditNoteList?.totalCount}
                </p>
              </div>
              <div className=" flex flex-wrap items-center md:justify-start rounded-[8px] gap-3 mt-3 xl:mt-0">
              {getActiveFilterCount() > 0 && (
                  <div className="z-10 flex gap-3">
                    <button
                      className="bg-[#fae006] hover:bg-[#fae006]/80 py-1 px-2  rounded-[4px] del-tooltip "
                      onClick={clearAllFilters}
                    >
                      <div className="flex items-center gap-2">
                      <img src={ClearFilter} className=" w-7 h-7" alt="new"></img>
                      </div>
                      <span className="text-sm del-tooltiptext font-Poppins">Clear Filter</span>
                    </button>
                  </div>
                )}
              <button
                  onClick={toggleSidebar}
                  className="inline-flex items-center px-4 py-2  rounded-lg text-sm font-medium  bg-[#fae006] hover:bg-[#fae006]/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                  <Filter className="w-4 h-4 mr-2" />
                  Filters
                </button>
                <div className="relative ">
                  <button
                    className=" bg-[#fae006] flex px-4 rounded-[8px] text-sm items-center py-2 font-medium"
                    onClick={() => setopenCalender(!openCalender)}
                  >
                    <img
                      src={calender}
                      className="mr-[12px] w-4 h-4"
                      alt="calenderimg"
                    ></img>
                    {selectionRange
                      ? `${formattedStartDate(
                          selectionRange.startDate
                        )} - ${formattedStartDate(selectionRange.endDate)}`
                      : "Select Date"}
                  </button>
                  {openCalender && (
                    <div className="absolute z-50 md:right-0" ref={ref}>
                      <DateRangePicker
                        ranges={[
                          selectionRange || {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: "selection",
                          },
                        ]}
                        onChange={handleSelection}
                        rangeColors={["#FCDD00"]}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        maxDate={new Date()}
                        popperProps={{
                          strategy: "fixed",
                        }}
                        direction="horizontal"
                      />
                    </div>
                  )}
                </div>
                {
                  CreditNoteList?.data?.length > 0 && (
                    <button
                    className=" bg-[#fae006] text-sm flex px-4 rounded-[8px] py-2 font-medium disabled:bg-[#fae006]/80 disabled:cursor-not-allowed"
                    onClick={() => handleExportData()}
                >
                  Export
                </button>
                  )
                }
              </div>
              {error && <p className="text-[#ff0000]">{error}</p>}
            </div>
          </div>
          {/* {/ --------------------------------------------Content Table------------------------------------------------------- /} */}
          <div className="flex-1 overflow-auto scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100">
            {CreditNoteList.data?.length === 0 ? (
              <div className="flex items-center justify-center h-full">
                <p className="text-xl font-Roboto ">
                  No Refund Data Available.
                </p>
              </div>
            ) : (
              <table className="corporate-table w-[100%]  text-left font-Poppins">
                <thead>
                  <tr style={{ zIndex: 5 }}>
                    <th>
                      <div className="min-w-[190px] pl-[40px] py-2 xl:py-3">
                        Branch Name
                      </div>
                    </th>
                    <th>
                      <div className="min-w-[160px]">Member Name</div>
                    </th>
                    <th>
                      <div className="min-w-[190px]">Email Id</div>
                    </th>
                    <th>
                      <div className="min-w-[130px]">Contact No.</div>
                    </th>
                    <th>
                      <div className="min-w-[80px]">Qty</div>
                    </th>
                    <th>
                      <div className="min-w-[100px]">Amount</div>
                    </th>
                    <th>
                      <div className="min-w-[120px]">Invoice No.</div>
                    </th>
                    <th>
                      <div className="min-w-[140px]">Register Date</div>
                    </th>
                    <th>
                      <div className="min-w-[140px]">Approval Date</div>
                    </th>
                    <th>
                      <div className="min-w-[100px]">Status</div>
                    </th>
                    <th>
                      <div className="min-w-[80px]  ">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {CreditNoteList?.data?.map((user, index) => (
                    <tr key={index}>
                      <td className="pl-[40px] capitalize py-2 xl:py-4  h-[46px]">
                        {user?.BranchName && user?.BranchName ? (
                          user.BranchName?.length > 16 ? (
                            <div className="tooltip">
                              <span className="">
                                {user.BranchName?.substring(0, 16)}...
                              </span>
                              <span className="tooltiptext ">
                                {user.BranchName}
                              </span>
                            </div>
                          ) : (
                            <span className="">
                              {user.BranchName}
                            </span>
                          )
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      {user?.name?.length > 21 ? (
                        <td>
                          <div className="capitalize tooltip ">
                            {`${user?.name?.substring(0, 21)}...`}
                            <span className="tooltiptext ">
                              {user.name}
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td className="capitalize ">
                          <div>{user.name}</div>
                        </td>
                      )}

                      {user?.email?.length > 20 ? (
                        <td>
                          <div className="tooltip ">
                            {`${user?.email?.substring(0, 20)}...`}
                            <span className="w-auto tooltiptext wrap">
                              {user.email}
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div className="">{user.email}</div>
                        </td>
                      )}

                      <td>
                        <p className="">{user.contact}</p>
                      </td>
                      <td>
                        <p className="">
                          {user.quentity ? user.quentity : "-"}
                        </p>
                      </td>
                      <td>
                        <p className="">
                          {user.amount ? user.amount : "-"}
                        </p>
                      </td>
                      <td>
                        <p className="">{user.invoiceNo}</p>
                      </td>
                      <td>
                        <p className="">
                          {user.refund_Req_Date &&
                            formatToIST(user.refund_Req_Date)}
                        </p>
                      </td>
                      <td>
                        <p className="">
                          {user.Refund_Approve_Date
                            ? formatToIST(user.Refund_Approve_Date)
                            : "-"}{" "}
                        </p>
                      </td>
                      <td>
                        <p
                          className="capitalize "
                          style={{
                            color:
                              user.refund_status === "pending"
                                ? "black"
                                : user.refund_status === "reject"
                                ? "red"
                                : "green",
                          }}
                        >
                          {user.refund_status}
                        </p>
                      </td>
                      <td>
                        <div className="flex gap-4">
                          {user.refund_status === "approve" ||
                          user.refund_status === "reject" ? (
                            <span className="mr-4">-</span>
                          ) : (
                            <div className="del-tooltip">
                              <Eye
                                className="w-6 h-6 cursor-pointer"
                                onClick={() => {
                                  setRefundModal(true);
                                  setuserDetail(user);
                                }}
                              />
                              <span className="text-sm del-tooltiptext" >View</span>
                            </div>
                          )}
                          <div className="cursor-pointer del-tooltip">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"   onClick={() => {
                                setProcessModal(true);
                                setuserDetail(user);
                                setRefundProcessData(user.req_id);
                              }}>
<path d="M1 12C1 14.1756 1.64514 16.3023 2.85383 18.1113C4.06253 19.9202 5.78049 21.3301 7.79048 22.1627C9.80047 22.9952 12.0122 23.2131 14.146 22.7886C16.2798 22.3642 18.2398 21.3165 19.7782 19.7782C21.3165 18.2398 22.3642 16.2798 22.7886 14.146C23.2131 12.0122 22.9952 9.80047 22.1627 7.79048C21.3301 5.78049 19.9202 4.06253 18.1113 2.85383C16.3023 1.64514 14.1756 1 12 1C8.92483 1.01157 5.97318 2.21149 3.76222 4.34889L1 7.11111" stroke="#2C2C2C" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 1V7.11111H7.11111" stroke="#2C2C2C" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 8H16.3333" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 11.0576H16.3333" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 14.1104L14.1944 19" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 14.1104H10.8333" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.8281 14.112C14.9024 14.112 14.9024 8 10.8281 8" stroke="#2C2C2C" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            <span className="text-sm del-tooltiptext">Process</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {/* {/ --------------------------------------------Footer---------------------------------------------------------- /} */}
          {CreditNoteList?.data?.length > 0 && (
            <div className="sticky bottom-0 mt-3 bg-white footer-content">
              <div className="items-center justify-between md:flex">
                <div className="flex items-center gap-2 mb-3 md:mb-0">
                  <p className="capitalize">View</p>
                  <div className="">
                    <Menu as="div" className="relative text-left">
                      <div>
                        <Menu.Button className="flex px-[10px] ml-[10px] min-h-[37px] bg-white border-2 border-[#F2F2F2] min-w-[60px] rounded-[8px] justify-between  text-sm font-poppins font-medium  items-center ">
                          <p className="text-[#47505F] font-medium font-[poppins]">
                            {page}
                          </p>
                          <img src={LimitArrow} alt="LimitArrow" />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="bottom-full absolute right-0 z-10 mt-2 py-2 w-[70%] rounded-[12px] bg-white shadoe-sm focus:outline-none border  mb-2">
                          {itemsPerPageOptions?.map((e) => (
                            <div key={e?.id}>
                              <Menu.Item>
                                {({ active }) => (
                                  <p
                                    className={classNames(
                                      active
                                        ? "bg-[#FFFCE1] text-[#1A1A1A]"
                                        : "",
                                      "block px-2 py-2 text-sm cursor-pointer"
                                    )}
                                    onClick={() => onselectedpage(e)}
                                  >
                                    {e?.value}
                                  </p>
                                )}
                              </Menu.Item>
                            </div>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
                {/* {/ --------------------------------------------Footer Pagination---------------------------------------------------------- */}
                <div className="flex items-center mt-3 md:mt-0">
                  <button
                    className="cursor-pointer text-[#000] text-sm h-[35px] border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                    onClick={handleFirstPage}
                  >
                    &lt;&lt;
                  </button>
                  <div className="hidden text-sm md:block">
                    <ReactPaginate
                      {...reactPaginate}
                      breakLabel="..."
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                    />
                  </div>
                  <div className="text-sm md:hidden">
                    <ReactPaginate
                      {...reactPaginate}
                      marginPagesDisplayed={0}
                      pageRangeDisplayed={1}
                    />
                  </div>
                  <button
                    className="cursor-pointer text-[#000] text-sm h-[35px] border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                    onClick={handleLastPage}
                  >
                    &gt;&gt;
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {editEmpModel && (
          <EditEmployeeModal {...{ setEditEmpModel, userDetail }} />
        )}
        {refundModal && (
          <RefundApproveModal {...{ setRefundModal, userDetail ,refundModal}} />
        )}
        {approveReasonModel && (
          <ApproveSureModel
            {...{ setApproveReasonModel, userDetail, setRefundModal }}
          />
        )}
        {
          processModal && (
            <ProcessRefundModel {...{ setProcessModal, userDetail, currentStepData ,getDataRefundProcessSteps,subStep}} />
          )
        }
                {isSidebarOpen && (
          <FilterSidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            filters={filters}
            onFilterChange={handleFilterChange}
            optionList={optionList}
            selectedCorporate={selectedCorporate}
            statusOptions={statusOptions}
            Search={Search}
            startDate={searchParams.get("startDate")?searchParams.get("startDate"):null}
            endDate={searchParams.get("endDate")?searchParams.get("endDate"):null}
            setselectpage={setselectpage}
                        handelFilterApply={handelFilterApply}

          />
        )}

        {/* Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
        {processModal && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setProcessModal(false)}
          />
        )}


         {approveReasonModel && (
                  <ApproveSureModel
                    {...{ setApproveReasonModel, userDetail, setRefundModal }}
                  />
                )}
                 {showDateWarning && (
                    <ExportRangeSelectModel
                      openModel={showDateWarning}
                      onClose={() => setShowDateWarning(false)}
                    />
                  )}
        {showExportModel && (
          <ExportModel
            isOpen={showExportModel}
            onClose={() => setShowExportModel(false)}
            exportData={handleExportData}
          />
        )}
      </AdminLayout>
    </>
  );
};
export default CreditNote;
